import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, Input, OnDestroy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { FikoYTService } from '@/src/service/fikoyt.service';
import * as THREE from 'three';
import { FikoIsikOrtam } from '../../FikoIsikOrtam';

declare var $: any;

@Component({
  selector: 'fikoyt-fiko-isik-ortam',
  templateUrl: './fiko-isik-ortam.component.html',
  styleUrls: ['./fiko-isik-ortam.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule]
})
export class FikoIsikOrtamComponent implements OnDestroy {
  id_dialog = "dialogFikoIsikOrtam" + this.FikoYT.fikoIdUret();
  subsList: Subscription[] = [];

  @Input() nesne: FikoIsikOrtam;
  @Input() pencere: any; // Dialog Core'dan gelen pencere referansı

  constructor(public readonly FikoYT: FikoYTService, public readonly CD: ChangeDetectorRef) {
    this.subsList.push(FikoYT.degisti.subscribe(() => {
      this.CD.detectChanges();
    }))
  }



  renkDegisti($event: any) {
   this.nesne.color.set(new THREE.Color($event));
   this.nesne.sahne.anaGosterim.ciz();
  }

  public kapa() {
    // Dialog core'ın kapa metodunu çağır
    // FikoDialogCore'dan { instance: this } şeklinde gelir
    if (this.pencere?.instance && typeof this.pencere.instance.kapa === 'function') {
      try {
        this.pencere.instance.kapa();
        return;
      } catch (error) {
      }
    }

    // Fallback: direkt pencere.kapa() dene (eski pattern için)
    if (this.pencere && typeof this.pencere.kapa === 'function') {
      try {
        this.pencere.kapa();
        return;
      } catch (error) {
      }
    }
  }

  ngOnDestroy(): void {
    $("#" + this.id_dialog).remove();
    this.subsList.forEach(element => {
      element.unsubscribe();
    });
  }
}
